import { Box, Typography } from '@mui/material';

import SectionTitle from '../../components/SectionTitle';

const contents = [
  'Bác sĩ của bạn đã khuyên bạn cần phải nhận một lượng máu hoặc sản phẩm máu từ những người tình nguyện hiến máu. Quá trình truyền máu là cần thiết để thay thế một phần của',
  'máu của bạn và được thực hiện để:',
  'thay thế hồng cầu để điều trị hoặc ngăn ngừa thiếu máu, cải thiện việc vận chuyển oxy và giảm các triệu chứng chóng mặt, mệt mỏi hoặc khó thở ',
  'cung cấp thêm tiểu cầu để giúp cầm máu hoặc ngăn ngừa chảy máu ',
  'cung cấp một sản phẩm plasma để ngăn chặn, điều trị hoặc ngăn ngừa chảy máu.',
  'Truyền máu được thực hiện thông qua ống dẫn (kim chọc vào tĩnh mạch của bạn) hoặc thông qua một đường trung tâm vào tĩnh mạch của bạn. Trong quá trình truyền máu, bạn sẽ\nđược theo dõi chặt chẽ để phát hiện ra bất kỳ phản ứng nào có thể xảy ra. Bạn cũng sẽ được kiểm tra thường xuyên để xem liệu bạn có cần phải nhận một lần truyền máu khác không.',
  'Bác sĩ đã giải thích rằng tôi có tình trạng sức khỏe sau đây đòi hỏi tôi cần một lần truyền máu: (Bác sĩ ghi lại theo lời của bệnh nhân)',
];

const BContents = () => {
  return (
    <>
      <SectionTitle title="B. Tại sao tôi lại cần truyền máu?" />
      <Box
        sx={{
          width: '98%',
          margin: '48px auto 20px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents.map((v, i) => {
          if (i > 1 && i < 5) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                • {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '15px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
            </Typography>
          );
        })}
      </Box>
      <Box
        sx={{
          width: '98%',
          margin: '0px auto 20px auto',
        }}
      >
        <Typography
          sx={{
            fontWeight: '400',
            fontSize: '15px',
            lineHeight: '24px',
            whiteSpace: 'pre-wrap',
          }}
        >
          Tình trạng sức khỏe của bạn yêu cầu các sản phẩm máu sau đây.
          <br />
          Bác sĩ liệt kê sản phẩm và tần suất điều trị. (Bác sĩ có thể chỉ ra
          rằng tần suất có thể thay đổi trong quá trình điều trị)
        </Typography>
      </Box>
    </>
  );
};

export default BContents;
